<template>
  <div v-if="!(externalRegion && displayedEvents.length == 0)" class="col-100" :class="{
    'col-lg-75': !externalRegion || externalRegion === '' && screenWidth < 922,
    'pe-0 ps-0': externalRegion
  }">
    <button v-if="!externalRegion" @click="openFilter" class="filterToggle" title="Filter öffnen" type="button">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
      </svg>
    Filter
    </button>
    <div v-if="eventStore.searched" class="search-count">{{ eventStore.loading || eventStore.searchLoading ? 'Lädt' : displayedEvents.length }} {{ displayedEvents.length == 1 ? `Veranstaltung wurde mit Ihrem Suchbegriff "${eventStore.searchedTerm}" im Angebotstitel oder in der Beschreibung gefunden` : `Veranstaltungen wurden mit Ihrem Suchbegriff "${eventStore.searchedTerm}" im Angebotstitel oder in der Beschreibung gefunden` }}</div>
    <div class="products" :class="{'products--region' : externalRegion.length > 0}">
      <div class="products__header">
        <div class="products__headertitle">
          
        </div>
        <div v-if="externalRegion.length > 0" class="products__headertitle">
          
        </div>
        <div class="products__headertitle">
          Angebotstitel
        </div>
        <div class="products__headertitle">
          Themenwelt
        </div>
        <div class="products__headertitle">
          Datum
        </div>
        <div class="products__headertitle">
          Ort
        </div>
        <div class="products__headertitle products__headertitle--wishlist">
          Merken
        </div>
      </div>
    </div>
    <div class="products__body">
      <template v-if="!eventStore.loading && !eventStore.searchLoading">
        <template v-for="(product, index) in displayedEvents">
          <ListItem
            v-if="index < activePage * elementsPerPage && index >= (activePage - 1) * elementsPerPage"
            :key="product.id"
            :product="product"
            :image="externalRegion.length > 0"
          />
        </template>
        <div v-if="eventStore.filteredEvents.length <= 0" class="products__no-result">
          <strong>Keine Ergebnisse gefunden.</strong><br> Bitte passen Sie Filter und Suche an...
        </div>
        <div v-if="totalPages > 1" class="pagination">
          <button @click.prevent="activePage--" @click="scrollToTop" aria-label="Vorherige Seite">Vorherige<span v-if="screenWidth >= 1200 || screenWidth < 768">&nbsp;Seite</span></button>
          <div class="pagination__list">
            <button v-if="screenWidth >= 768" :aria-label="btn !== '...' ? `Seite ${btn}` : 'Lückenfüller Button mit drei Punkten'" v-for="btn in paginationButtons" :class="{'active' : btn == activePage}" @click="scrollToTop" @click.prevent="activePage = btn !== '...'  ? btn : activePage" :disabled="btn == '...'">{{ btn }}</button>
            <select v-if="screenWidth < 768" v-model="activePage" aria-label="Seitenauswahl">
              <option v-for="page of totalPages" :value="`${page}`">Seite {{ page }}</option>
            </select>
          </div>
          <button @click.prevent="activePage++" @click="scrollToTop" aria-label="Nächste Seite">Nächste<span v-if="screenWidth >= 1200 || screenWidth < 768">&nbsp;Seite</span></button>
        </div>
      </template>
      <template v-else>
        <!-- LOADING STATE -->
        <div class="loading">
          <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed, ref, watch, onUnmounted } from 'vue';

import ListItem from '../../components/ListItem.vue';
import { defineStore } from 'pinia';

const open = ref(false);
const openFilter = () => {
  eventStore.openFilter = true;
}

const props = defineProps({
  externalRegion: String
})

const useEventStore = defineStore('event');
const useBookmarkStore = defineStore('bookmark');

const eventStore = useEventStore();
const bookmarkStore = useBookmarkStore();

const displayedEvents = computed(() => eventStore.filteredEvents);

const startingPage = ref(1);
const elementsPerPage = ref(27);
const totalPages = computed (() => Math.ceil(eventStore.filteredEvents.length / elementsPerPage.value));

const activePage = computed({
  get: () => startingPage.value,
  set: (newVal) => {
    if (newVal < 1){
      startingPage.value = 1;
    } else if (newVal > totalPages.value) {
      startingPage.value = totalPages.value
    } else {
      startingPage.value = newVal;
    }
  }
})

const scrollToTop = () => {
  const scrollTo = document.querySelector('.productsrow');
  const header = document.querySelector('.navbar');
  const topmeta = document.querySelector('.topmeta')
  const headerHeight = header.offsetHeight;
  const topmetaHeight = topmeta.offsetHeight;

  const elementPosition = scrollTo.getBoundingClientRect().top + window.scrollY;
  const offsetPosition = elementPosition - headerHeight - topmetaHeight;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth'
  });
}

/*
*   computed property, um die richtigen Buttons für Pagination zu generieren
*/

const paginationButtons = computed(() => {
  const buttons = [];

  activePage.value = Number.parseInt(activePage.value);

  if (totalPages.value <= 7) {
    // Wenn es wenige Seiten gibt, zeige alle Buttons
    for (let i = 1; i <= totalPages.value; i++) {
      buttons.push(i);
    }
  } else {
    // Sonderfälle für Anfang und Ende mit "..."
    if (activePage.value <= 4){
      for (let i = 1; i < 6; i++) {
        buttons.push(i);
      }
      buttons.push("...");
      buttons.push(totalPages.value);
    } else if (activePage.value >= totalPages.value - 3) {
      buttons.push(1);
      buttons.push("...");
      for (let i = totalPages.value - 4; i <= totalPages.value; i++) {
        buttons.push(i);
      }
    } else {
      buttons.push(1);
      buttons.push("...");
      buttons.push(activePage.value - 1);
      buttons.push(activePage.value);
      buttons.push(activePage.value + 1);
      buttons.push("...");
      buttons.push(totalPages.value);
    }
  }

  return buttons;
});

watch(() => displayedEvents.value, newVal => {
  activePage.value = 1;
})

/*
*   Mediabreakpoint für Pagination beobachten
*/

const screenWidth = ref(window.innerWidth);

const updateScreenWidth = () => {
  screenWidth.value = window.innerWidth;
}

onMounted(async () => {
  window.addEventListener('resize', updateScreenWidth);
  if(props.externalRegion) {
    eventStore.searched = false;
  }
});

onUnmounted(() => {
  window.removeEventListener('resize', updateScreenWidth);
})
</script>
